import { Result } from "@pacote/result"
import useSWRMutation from "swr/mutation"
import { v4 as uuidV4 } from "uuid"
import { z } from "zod"
import { baseClientFetcher } from "./base-fetchers"
import {
  ComputedLoginFields,
  handleLoginResult,
  LoginErrorResponse,
  TloginErrorResponse,
} from "./post-login-sso"
import {
  BaseLoginV3Payload,
  ssoLoginV3ResponseSchema,
} from "./post-login-sso-v3"

type OAuthLoginV2Payload = BaseLoginV3Payload & {
  pvd?: string
}

const oAuthLoginV2ResponseSchema = ssoLoginV3ResponseSchema.extend({
  redirect: z.string().optional(),
})

type OAuthLoginV2Response = z.infer<typeof oAuthLoginV2ResponseSchema>

export type TOAuthLoginV2Response = OAuthLoginV2Response & ComputedLoginFields

type OAuthLoginV2Result = Result<TOAuthLoginV2Response, TloginErrorResponse>

export const oAuthLoginV2Endpoint = "/authentication-ms/v2/oauth/login"

const oAuthLoginV2Fetcher = async (
  key: string,
  { arg }: { arg: OAuthLoginV2Payload },
): Promise<OAuthLoginV2Result> => {
  const sessionId = uuidV4()

  const loginServiceResult = await baseClientFetcher<
    OAuthLoginV2Response,
    LoginErrorResponse
  >(
    {
      url: key,
      method: "POST",
      headers: {
        "X-Session-Id": sessionId,
      },
      body: {
        username: arg.username,
        password: arg.password,
        pvd: arg.pvd ?? "BO9999",
        recaptchaToken: arg.recaptchaToken,
        device: arg.device,
      },
      successSchemaValidator: oAuthLoginV2ResponseSchema,
      throwOnValidationError: true,
    },
    { enrichRequestData: false },
  )

  return await handleLoginResult(loginServiceResult, arg.channel, sessionId)
}

export const useOAuthLoginV2Mutation = () =>
  useSWRMutation(oAuthLoginV2Endpoint, oAuthLoginV2Fetcher, {
    populateCache: true,
  })
